// Les brouillons ont deux origines : une déclaration client soumise par QR code,
// et un colis détaché d'un départ. Ils se traitent pareil — modifier ou valider —
// donc l'écran n'en fait qu'une liste.
// Fonctions pures : aucune dépendance React ni réseau.

const normalizeSubmission = (submission) => {
  const pkg = submission.draft_package || {};
  const data = submission.client_data || {};
  const pick = (key) => pkg[key] ?? data[key] ?? '';

  return {
    key: `submission-${submission.session_id}`,
    kind: 'submission',
    sessionId: submission.session_id,
    packageId: pkg.id || null,
    oce_code: pkg.oce_code || '',
    sender_name: pick('sender_name'),
    recipient_name: pick('recipient_name'),
    weight: pick('weight'),
    origin_country: pick('origin_country'),
    destination_country: pick('destination_country'),
    destination_city: pick('destination_city'),
    description: pick('description'),
    payment_status: pick('payment_status'),
    payment_method: pick('payment_method'),
    advance_amount: pick('advance_amount'),
    price: pick('price'),
    source: submission,
  };
};

const normalizePackage = (pkg) => ({
  key: `package-${pkg.id}`,
  kind: 'package',
  sessionId: pkg.qr_session_id || null,
  packageId: pkg.id,
  oce_code: pkg.oce_code || '',
  sender_name: pkg.sender_name || '',
  recipient_name: pkg.recipient_name || '',
  weight: pkg.weight ?? '',
  origin_country: pkg.origin_country || '',
  destination_country: pkg.destination_country || '',
  destination_city: pkg.destination_city || '',
  description: pkg.description || '',
  payment_status: pkg.payment_status || '',
  payment_method: pkg.payment_method || '',
  advance_amount: pkg.advance_amount || 0,
  price: pkg.price ?? '',
  source: pkg,
});

/**
 * Liste unique des brouillons. Les déclarations QR passent d'abord ; un colis
 * déjà porté par une déclaration n'est pas répété.
 */
export function mergeDraftItems(submissions = [], packages = []) {
  const items = (submissions || []).map(normalizeSubmission);
  const covered = new Set(items.map((item) => item.packageId).filter(Boolean));

  (packages || []).forEach((pkg) => {
    if (pkg?.id && !covered.has(pkg.id)) items.push(normalizePackage(pkg));
  });

  return items;
}
